import { css } from "styled-components";

export const Direction = {
  Up: "up",
  Down: "down",
  Left: "left",
  Right: "right",
};
const arrowSize = 10;

/* eslint-disable consistent-return, default-case */
function inverseDirection(direction) {
  switch (direction) {
    case Direction.Left:
      return Direction.Right;
    case Direction.Right:
      return Direction.Left;
    case Direction.Up:
      return Direction.Down;
    case Direction.Down:
      return Direction.Up;
  }
}
/* eslint-enable */

const baseArrowCss = css`
  position: relative;

  &:after,
  &:before {
    border: solid transparent;
    content: " ";
    height: 0;
    width: 0;
    position: absolute;
    pointer-events: none;
  }

  &:after {
    border-width: ${arrowSize}px;
  }

  &:before {
    border-width: ${({ theme: { border } }) =>
      `calc(${arrowSize}px + ${border.width}*1.5);`};
  }
`;

function getArrowAxisCss(direction) {
  const axis =
    direction === Direction.Left || direction === Direction.Right
      ? Direction.Up
      : Direction.Left;

  return css`
    &:after,
    &:before {
      ${axis}: 50%;
    }
    &:after {
      margin-${axis}: -${arrowSize}px;
    }
    &:before {
      margin-${axis}: ${({ theme: { border } }) =>
    `calc(-${arrowSize}px - ${border.width}*1.5);`}
    }
  `;
}

function getArrowDirectionCss(direction, { primaryBorder, primaryBackground }) {
  const arrowDirection = inverseDirection(direction);

  return css`
    &:after,
    &:before {
      ${arrowDirection}: 100%;
    }
    &:after {
      border-${arrowDirection}-color: ${({ theme }) =>
    primaryBackground
      ? theme.colors.primary.lighter
      : theme.colors.greys.white};
    }
    &:before {
      border-${arrowDirection}-color: ${({ theme }) =>
    primaryBorder ? theme.colors.primary.dark : theme.colors.greys.light};
    }
  `;
}

// eslint-disable-next-line
export default function getCssArrow(direction, primaryColors) {
  return css`
    ${baseArrowCss} ${getArrowAxisCss(direction)} ${getArrowDirectionCss(
      direction,
      primaryColors,
    )};
  `;
}
